import React, {RefObject, useEffect, useState} from "react";
import {Box, Fab, Fade} from "@mui/material";
import {KeyboardArrowUp} from "@material-ui/icons";
import {makeStyles, useTheme} from "@material-ui/core";
import clsx from "clsx";

type BackToTopButtonProps = {
  anchor: RefObject<HTMLDivElement>;
  className?: string;
  showAfterHeight?: number;
};

function BackToTopButton({
  anchor,
  showAfterHeight = 50,
  className,
}: BackToTopButtonProps) {
  const [shouldShow, setShouldShow] = useState(false);
  const classes = useStyles();
  const theme = useTheme();

  const handleClick = () => {
    if (anchor?.current) {
      anchor.current.scrollTo({top: 0, behavior: "smooth"});
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentTopScroll = anchor?.current?.scrollTop || 0;
      if (currentTopScroll > showAfterHeight) {
        setShouldShow(true);
      } else {
        setShouldShow(false);
      }
    };

    if (anchor?.current) {
      anchor.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (anchor?.current) {
        anchor.current?.removeEventListener("scroll", () =>
          setShouldShow(false)
        );
      }
    };
  }, [anchor, showAfterHeight]);

  return (
    <Fade in={shouldShow}>
      <Box
        onClick={handleClick}
        role="presentation"
        className={clsx(className, classes.root)}
      >
        <Fab size="small" className={classes.fab}>
          <KeyboardArrowUp htmlColor={theme.palette.primary.main} />
        </Fab>
      </Box>
    </Fade>
  );
}

const useStyles = makeStyles(() => ({
  root: {
    position: "absolute",
    bottom: "16px",
    right: "16px",
  },
  fab: {
    backgroundColor: "white",
  },
}));

export default BackToTopButton;
